export default __webpack_public_path__ + "static/media/ParentsLearningCenterPicture.8462841c.jpg";